var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "custom-html-editor d-flex flex-row"
  }, [_c('div', {
    staticClass: "editor-main d-flex flex-column flex-grow-1"
  }, [_c('div', {
    staticClass: "html-editor-section flex-grow-1 d-flex flex-column"
  }, [_c('div', {
    staticClass: "section-header d-flex align-center justify-space-between px-3 py-1"
  }, [_c('v-btn-toggle', {
    staticClass: "view-toggle",
    attrs: {
      "mandatory": "",
      "dense": ""
    },
    model: {
      value: _vm.viewMode,
      callback: function callback($$v) {
        _vm.viewMode = $$v;
      },
      expression: "viewMode"
    }
  }, [_c('v-btn', {
    attrs: {
      "value": "code",
      "text": "",
      "x-small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-code-tags")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_view_code')) + " ")], 1), _c('v-btn', {
    attrs: {
      "value": "visual",
      "text": "",
      "x-small": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-eye")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_view_visual')) + " ")], 1)], 1), _c('div', [_vm.localHtml && _vm.localHtml.trim() ? _c('v-btn', {
    attrs: {
      "text": "",
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        _vm.changeTemplateModal = true;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-file-swap-outline")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_change_template')) + " ")], 1) : _vm._e(), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.viewMode === 'code',
      expression: "viewMode === 'code'"
    }],
    attrs: {
      "text": "",
      "x-small": ""
    },
    on: {
      "click": _vm.formatCode
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-format-indent-increase")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_format')) + " ")], 1), _c('v-btn', {
    attrs: {
      "text": "",
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        _vm.variablesPanel = !_vm.variablesPanel;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-code-braces")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_variables_title')) + " ")], 1), _vm.isAllowed('is_ste') ? _c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "color": _vm.chatOpen ? 'primary' : ''
    },
    on: {
      "click": function click($event) {
        _vm.chatOpen = !_vm.chatOpen;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-robot")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_ai_chat')) + " ")], 1) : _vm._e()], 1)], 1), _c('v-expand-transition', [_vm.variablesPanel ? _c('div', {
    staticClass: "variables-panel px-3 py-2"
  }, [_c('div', {
    staticClass: "variables-hint mb-1"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_variables_hint')))]), _c('div', {
    staticClass: "variables-grid"
  }, _vm._l(_vm.availableVariables, function (variable) {
    return _c('div', {
      key: variable.path,
      staticClass: "variable-item",
      on: {
        "mousedown": function mousedown($event) {
          $event.preventDefault();
        },
        "click": function click($event) {
          return _vm.insertVariable(variable.path);
        }
      }
    }, [_c('code', [_vm._v(_vm._s('{' + variable.path + '}'))]), _c('span', {
      staticClass: "variable-desc ml-1"
    }, [_vm._v(_vm._s(variable.name))])]);
  }), 0)]) : _vm._e()]), _vm.isLargeDoc && _vm.viewMode === 'code' ? _c('div', {
    staticClass: "large-file-notice px-3 py-1 d-flex align-center"
  }, [_c('v-icon', {
    attrs: {
      "x-small": "",
      "left": "",
      "color": "amber darken-3"
    }
  }, [_vm._v("mdi-information-outline")]), _c('span', [_vm._v(_vm._s(_vm.$t('custom_html_large_file_notice', {
    size: _vm.largeFileSizeLabel
  })))])], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.viewMode === 'code',
      expression: "viewMode === 'code'"
    }],
    staticClass: "codemirror-wrapper flex-grow-1"
  }, [_c('codemirror', {
    ref: "editor",
    attrs: {
      "options": _vm.editorOptions
    },
    on: {
      "input": _vm.onHtmlInput
    },
    model: {
      value: _vm.localHtml,
      callback: function callback($$v) {
        _vm.localHtml = $$v;
      },
      expression: "localHtml"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.viewMode === 'visual',
      expression: "viewMode === 'visual'"
    }],
    staticClass: "simplified-view-wrapper flex-grow-1"
  }, [_c('simplified-html-view', {
    ref: "simplifiedView",
    attrs: {
      "tab-id": _vm.tabId,
      "selected-block-id": _vm.selectedBlockForAI
    },
    on: {
      "update:selectedBlockId": function updateSelectedBlockId($event) {
        _vm.selectedBlockForAI = $event;
      },
      "update:selected-block-id": function updateSelectedBlockId($event) {
        _vm.selectedBlockForAI = $event;
      },
      "block-edited": _vm.onSimplifiedBlockEdit,
      "block-deleted": _vm.onBlockDeleted,
      "block-hover": _vm.onBlockHover,
      "template-selected": _vm.onTemplateSelected,
      "start-scratch": function startScratch($event) {
        _vm.viewMode = 'code';
      }
    }
  })], 1)], 1)]), _c('transition', {
    attrs: {
      "name": "slide-chat"
    }
  }, [_vm.chatOpen ? _c('div', {
    staticClass: "chat-panel d-flex flex-column"
  }, [_c('div', {
    staticClass: "chat-header d-flex align-center justify-space-between px-3 py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_ai_chat_title')))]), _c('v-btn', {
    attrs: {
      "icon": "",
      "x-small": ""
    },
    on: {
      "click": function click($event) {
        _vm.chatOpen = false;
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-close")])], 1)], 1), _c('div', {
    ref: "chatMessages",
    staticClass: "chat-messages flex-grow-1"
  }, [!_vm.chatHistory.length ? _c('div', {
    staticClass: "chat-empty pa-4"
  }, [_c('div', {
    staticClass: "chat-empty-icon mb-2"
  }, [_c('v-icon', {
    attrs: {
      "large": "",
      "color": "grey lighten-1"
    }
  }, [_vm._v("mdi-robot-outline")])], 1), _c('div', {
    staticClass: "font-weight-light text-center grey--text"
  }, [_vm._v(" " + _vm._s(_vm.$t('custom_html_ai_chat_empty')) + " ")])]) : _vm._e(), _vm._l(_vm.chatHistory, function (msg, index) {
    return _c('div', {
      key: index,
      staticClass: "chat-message pa-3",
      class: 'chat-' + msg.role
    }, [_c('div', {
      staticClass: "chat-role mb-1"
    }, [_c('v-icon', {
      staticClass: "mr-1",
      attrs: {
        "x-small": ""
      }
    }, [_vm._v(_vm._s(msg.role === 'user' ? 'mdi-account' : 'mdi-robot'))]), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(msg.role === 'user' ? _vm.$t('custom_html_ai_chat_you') : _vm.$t('custom_html_ai_chat_ai')))])], 1), _c('div', {
      staticClass: "chat-content"
    }, [_vm._v(_vm._s(msg.content))])]);
  }), _vm.aiGenerating ? _c('div', {
    staticClass: "chat-message chat-assistant pa-3"
  }, [_c('div', {
    staticClass: "chat-role mb-1"
  }, [_c('v-icon', {
    staticClass: "mr-1",
    attrs: {
      "x-small": ""
    }
  }, [_vm._v("mdi-robot")]), _c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_ai_chat_ai')))])], 1), _c('div', {
    staticClass: "chat-content typing"
  }, [_c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  }), _c('span', {
    staticClass: "dot"
  })])]) : _vm._e()], 2), _vm.canUndo || _vm.canRedo ? _c('div', {
    staticClass: "chat-undo-bar d-flex align-center justify-center pa-1"
  }, [_c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "disabled": !_vm.canUndo
    },
    on: {
      "click": _vm.undoAiChange
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-undo")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_undo')) + " ")], 1), _c('v-btn', {
    attrs: {
      "text": "",
      "x-small": "",
      "disabled": !_vm.canRedo
    },
    on: {
      "click": _vm.redoAiChange
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "x-small": ""
    }
  }, [_vm._v("mdi-redo")]), _vm._v(" " + _vm._s(_vm.$t('custom_html_redo')) + " ")], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "chat-input-area pa-2"
  }, [_c('div', {
    staticClass: "d-flex align-center"
  }, [_c('v-text-field', {
    staticClass: "chat-input",
    attrs: {
      "placeholder": _vm.chatHistory.length ? _vm.$t('custom_html_ai_chat_followup') : _vm.$t('custom_html_ai_chat_placeholder'),
      "dense": "",
      "outlined": "",
      "hide-details": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        if ($event.ctrlKey || $event.shiftKey || $event.altKey || $event.metaKey) return null;
        return _vm.onChatEnter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.chatInput,
      callback: function callback($$v) {
        _vm.chatInput = $$v;
      },
      expression: "chatInput"
    }
  }), _c('v-btn', {
    staticClass: "ml-1",
    attrs: {
      "icon": "",
      "color": "primary",
      "disabled": !_vm.chatInput.trim() || _vm.aiGenerating,
      "loading": _vm.aiGenerating
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('v-icon', [_vm._v("mdi-send")])], 1)], 1), _vm.aiError ? _c('div', {
    staticClass: "chat-error mt-1 px-1"
  }, [_c('span', {
    staticClass: "red--text text-caption"
  }, [_vm._v(_vm._s(_vm.aiError))])]) : _vm._e()])]) : _vm._e()]), _c('v-dialog', {
    attrs: {
      "width": "500"
    },
    model: {
      value: _vm.changeTemplateModal,
      callback: function callback($$v) {
        _vm.changeTemplateModal = $$v;
      },
      expression: "changeTemplateModal"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('custom_html_change_template_title')))]), _c('v-card-text', {
    staticClass: "py-4"
  }, [_vm._v(" " + _vm._s(_vm.$t('custom_html_change_template_warning')) + " ")]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        _vm.changeTemplateModal = false;
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _c('v-btn', {
    attrs: {
      "text": "",
      "color": "red"
    },
    on: {
      "click": _vm.confirmChangeTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('confirm')))])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }